module.exports = "<p>\n  part works!\n</p>\n"